import React from "react";
import { Formik, Form, Field } from "formik";
import { useNavigate } from "react-router-dom";
import { useData } from "../util/dataProvider";

export default function Password() {
  const { signIn, success, authError, resetPassword, registerError } =
    useData();

  const history = useNavigate();
  return (
    <div id="PasswordReset">
      <div className="big-title">Passwort vergessen</div>
      <div className="normal-text" style={{ marginBottom: "30px" }}>
        Bitte gebe deine E-Mail Adresse an, um dein Passwort zurückzusetzen
      </div>
      <Formik
        initialValues={{
          email: "",
        }}
        onSubmit={(values) => resetPassword(values.email)}
      >
        <Form style={{ display: "flex", flexDirection: "column" }}>
          <label htmlFor="email" className="label">
            E-Mail Adresse
          </label>
          <Field id="email" name="email" type="email" />

          <button className="button-green">Passwort zurückzusetzen</button>
          {registerError && <div className="error">{registerError}</div>}
          {success && <div className="success">{success}</div>}
        </Form>
      </Formik>
    </div>
  );
}
